import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { ActionCard } from '$/components/core/Projects/components/Cards/ActionCard';
import { useProjectModal } from '$/pages/DashboardPages/pages/Projects/hooks/useProjectModal';

export const AddProjectFolderButton = () => {
  const { t } = useTranslation();
  const onOpen = useProjectModal.useOnOpen();

  return (
    <Box
      as='button'
      data-testid='add-project-folder-button'
      onClick={() => onOpen('createProjectFolder')}
    >
      <ActionCard
        icon={<Icon icon='add_big' h='10' w='10' />}
        headerText={t('dashboard.projects.addProjectFolderButton')}
        background='bodyBackground'
        color='text'
      />
    </Box>
  );
};
